<div class="container">
    <h1 class="page-title"
    [helpCenterButton]="viewPermissionCode" [lang]="currentLang"
    [helpCenterDownloadButton]="viewPermissionCode" [position]="'inline'" [lang]="currentLang">
      <span class="icon"><i class="fas fa-scroll"></i></span>{{ 'Terms.Maintenance.Header' | translate }}</h1>
    <div class="login-input-wrapper">
      <label for="password">Language</label>
      <p-dropdown [(ngModel)]="language" [options]="languageOptions" (onChange)="languageChange($event)"
        class="ml-4"></p-dropdown>
    </div>
 <p-editor [(ngModel)]="laasTermsContent" [style]="{'height':'800px'}" >
  <ng-template pTemplate="header">
    <span class="ql-formats">
      <select class="ql-header">
        <option value="1">Heading</option>
        <option value="2">Subheading</option>
        <option selected>Normal</option>
      </select>
      <select class="ql-font">
        <option selected>Sans Serif</option>
        <option value="serif">Serif</option>
        <option value="monospace">Monospace</option>
      </select>
    </span>
    <span class="ql-formats">
      <button type="button" class="ql-bold" aria-label="Bold"></button>
      <button type="button" class="ql-italic" aria-label="Italic"></button>
      <button type="button" class="ql-underline" aria-label="Underline"></button>
    </span>
    <span class="ql-formats">
      <select class="ql-color"></select>
      <select class="ql-background"></select>
    </span>
    <span class="ql-formats">
      <button class="ql-list" value="ordered" aria-label="Ordered List" type="button"></button>
      <button class="ql-list" value="bullet" aria-label="Unordered List" type="button"></button>
    </span>
    <span class="ql-formats">
      <button class="ql-link" aria-label="Insert Link" type="button"></button>
      <button class="ql-image" aria-label="Insert Image" type="button"></button>
      <button class="ql-code-block" aria-label="Insert Code Block" type="button"></button>
    </span>
    <span class="ql-formats">
      <button class="ql-clean" aria-label="Remove Styles" type="button"></button>
    </span>
  </ng-template>
</p-editor>
<div class="grid mt-4">
  <div class="col">
      <button pButton pRipple label="{{ 'Announcement.Button.View' | translate }}" (click)="view()"></button>
      <button pButton pRipple label="{{ 'Common.Button.Save' | translate }}" (click)="save($event)" class="ml-2"></button>
      <button pButton pRipple label="{{ 'Announcement.Button.Release' | translate }}" class="ml-2 p-button-success" (click)="announcementBtnClick($event)"></button>
  </div>
</div>

<laas-terms-selector *ngIf="showTerms" (closeDialog)="closeDialog($event)" [contentView]="contentView" [isView]="true" [uuid]="uuid" [browserLanguage]="language" ></laas-terms-selector>

<help-dock
  [permissionCode]="viewPermissionCode"
  [lang]="currentLang">
</help-dock>
